import { CLOSE_THIRD_PARTY_DEMO_EXIT_CONFIRMATION } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function closeThirdPartyDemoExitConfirmation(options) {
  return callingAPIMethodWithQueue(CLOSE_THIRD_PARTY_DEMO_EXIT_CONFIRMATION, options);
}